export default "__VITE_ASSET__c7jCcF9o__"